import type { ModeId } from '@domain/modes/modes';
import { MODES } from '@domain/modes/modes';
import './ModePlaceholder.css';

export function ModePlaceholder(props: { mode: ModeId }) {
  const label = () => MODES.find((m) => m.id === props.mode)?.label ?? props.mode;
  return (
    <section class="mode-placeholder" aria-label={label()}>
      <p class="mode-placeholder__copy">This mode is not built yet. Heatmaps below already track it on its own.</p>
    </section>
  );
}
